
























import Vue from "vue";

import { FormOption } from "../../models/control";

import IconChevronNormal from "../../assets/icons/transparent/ChevronDown.svg";
import IconChevronActive from "../../assets/icons/default/ChevronDown.svg";

interface Props {
  // TODO: how to display error text?
  error?: string;
  // If only to trigger error styling only
  hasError: boolean;
  // Chevron cannot be imported with CSS relative path
  iconChevronNormal: string;
  // Unused as of Jun 2020, needs to handle mouseOver()
  iconChevronActive: string;
  // Customizable and optional left icon
  iconLeft?: string;
  // Customizable and optional right icon
  iconRight?: string;
  // Optional label
  label: string;
  options: FormOption<string | number>[];
  value: string;
}

export default Vue.extend<{}, {}, {}, Props>({
  name: "JzInputSelect",

  props: {
    error: { type: String, default: "" },
    hasError: { type: Boolean, default: false },
    iconChevronNormal: { type: String, default: IconChevronNormal },
    iconChevronActive: { type: String, default: IconChevronActive },
    iconLeft: { type: String, default: undefined },
    iconRight: { type: String, default: undefined },
    label: { type: String, default: "" },
    options: {
      type: Array as () => FormOption<string | number>[],
      required: true
    },
    value: { type: String, required: true }
  },

  computed: {
    styleChevron() {
      return `background-image: url(${this.iconChevronNormal};`;
    }
  }
});
